<template>
    <div>
        <b-modal
            id="confirm_redeem_gift_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="close-modal" @click="clickCloseConfirmRedeem()">
                    <img class="icon-close" src="@/assets/icon/ic-close3x.png" />
                </div>
                <div class="modal-base-head">
                    <div>{{lblConfirmRedeem.header}}</div>
                </div>
                <div class="modal-base-body">

                    <div class="gift-detail-wrapper">

                        <div class="gift-item">{{lblConfirmRedeem.name}} {{bookingImformation.firstName}} {{bookingImformation.lastName}}</div>
                        <div class="gift-item">{{lblConfirmRedeem.member_id}} {{bookingImformation.memberId}}</div>
                        <div class="gift-item">{{lblConfirmRedeem.branch}} {{bookingImformation.branch}}</div>
                        <div class="gift-item">{{lblConfirmRedeem.gift}} {{bookingImformation.gift}}</div>
                        <div class="gift-item">{{lblConfirmRedeem.use}} {{bookingImformation.point}}</div>

                        <div class="condition">
                            <img class="icon-check" @click="clickCheck()" v-if="isCheck" src="@/assets/icon/ic-check.png" />
                            <img class="icon-check" @click="clickCheck()" v-if="!isCheck" src="@/assets/icon/ic-un-check.png" />
                            {{lblConfirmRedeem.accept}}
                            <span class="condition-item" @click="clickOpenCondition()">{{lblConfirmRedeem.condition}}</span>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer btn-redeem-wrapper">
                    <button class="btn btn-cancel" @click="clickCloseConfirmRedeem()">{{lbl.gift_detail.cancel}}</button>
                    <button class="btn ml-2 btn-confirm" :class="{'disable' : !isCheck }"
                        @click="clickConfirmRedeem()">{{lbl.gift_detail.confirm}}</button>
                </div>

                <div class="border-item"> <img src="@/assets/icon/line-2@3x.png"/> </div>

                <div class="error-text" v-if="errorMessage">{{errorMessage}}</div>

                <div class="text-center">
                    <img width="88" src="@/assets/icon/bzbs-logo-black.png" />
                </div>

            </div>
        </b-modal>

        <modal view="test-store"
            :busModal="busModal"
            @modalAlertHidden="clickOkModalAlert($event)"></modal>

        <ConditionModal
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busCondition"
            @clickCloseCondition="clickCloseCondition()">
        </ConditionModal>
    </div>
</template>
<script>
// import Vue from "vue";

import Vue from "vue";
import Modal from '@/components/modal/Modal.vue';

import Util from "@/helper/Utility.js";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";
import ConditionModal from "./ConditionModal.vue";
//helper
import Account from '@/helper/AccountHelper.js';
import { TrackingService } from "@/helper/TrackingHelper";

export default {
    name: 'ConfirmCancelbookingModal',
    props: {
        lbl: Object,
        campaign: Object,
        busModal: Object,
        errorMessage: String,
    },
    components: {
        Modal,
        ConditionModal
    },
    data: function () {
        return {
            headline: '',
            message: '',
            bookingImformation: '',

            lblConfirmRedeem: {},
            lblDate: {},
            id: '',

            isCheck: false,

            busCondition: new Vue(),
            tracking: new TrackingService(this),
            trackCamp: null,
            userId: Account.getLineUserId()
        };
    },
    mounted: function () {

        this.lblConfirmRedeem = this.lbl.gift_detail.confirm_redeem;
        this.busModal.$on('showConfirmRedeemGiftModal', this.initialConfirmModal);
        this.busModal.$on('hideConfirmRedeemGiftModal', this.closeConfirmModal);

        this.trackCamp = this.userId + "|" + this.campaign.id + "|" + this.campaign.name;
    },
    methods: {
        clickCheck: function () {
            this.isCheck = !this.isCheck;
        },
        //Event
        clickConfirmRedeem: function () {
            if (!this.isCheck ) {
                return;
            }
            console.log(this.bookingImformation);
            this.$emit('clickConfirmRedeem', this.bookingImformation);
            // this.closeConfirmModal();
            this.tracking.event('Gift_List', 'click_Redemtion_success', this.trackCamp);
        },
        clickCloseConfirmRedeem: function () {
            this.isCheck = false;
            this.$emit('clickCancelSelectStore')
            this.closeConfirmModal();
            this.tracking.event('Gift_List', 'click_Redemtion_cancel', this.trackCamp);
        },
        //Function
        initialConfirmModal: function (data) {
            console.log(data);
            // this.headline = this.lblConfirmRedeem.reward_confirm;
            // this.message = this.lblConfirmRedeem.default1 + " " + this.campaign.pointPerUnit + " " + this.lblConfirmRedeem.default2;
           // var tmpInfo = JSON.parse(purchase.info3);

            var tmpImformation = {

                firstName: data.firstname,
                lastName: data.lastName,
                memberId: data.memberCode,
                branch: data.branch,
                gift: data.gift,
                point: data.point,
            }
            // console.log('tmpImformation', tmpImformation)
            this.bookingImformation = tmpImformation;
            // this.id = purchase;
            this.$bvModal.show('confirm_redeem_gift_modal');

        },
        closeConfirmModal: function () {
            this.$bvModal.hide('confirm_redeem_gift_modal');
        },
        clickCloseCondition: function () {

            this.$bvModal.show('confirm_redeem_gift_modal');
        },
        clickOpenCondition: function () {

            this.closeConfirmModal();
            this.busCondition.$emit('showModal');

        },
        //Utilities
        getTimerMessage: function (message, minutes) {
            var result = '';
            var days = '';
            var hours = '';
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lblDate.days + ' ';
            if (hours) result += hours + ' ' + this.lblDate.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        }
    }
}
</script>
<style lang="scss" scoped>
    #headline {
        text-align: center;
        font-weight: bold;
    }

    #message {
        text-align: center;
    }

    #confirm_redeem_gift_modal{

        .close-modal{
            text-align: right;

            .icon-close {
                width: 15px;
            }
        }

        .modal-base-head {
            color: #000000;
            font-weight: bold;
            font-size: 15px;
            text-align: center;
        }

        .gift-detail-wrapper {
            padding-top: 20px;
            padding-bottom: 30px;
            text-align: center;
            font-size: 12px;
            .head2 {
                padding-bottom: 20px;
                font-size: 15px;
                text-align: center;
            }
            .gift-item {
                padding-bottom: 6px;
            }
            .condition {
                margin-top: 6px;
                .icon-check {
                    width: 20px;
                    margin-right: 5px;
                }
                .condition-item {
                    text-decoration: underline;
                }
            }
            .question-mark{
                font-family: 'century';
            }
        }

        .btn-redeem-wrapper {
            text-align: center;
            display: flex;
            flex-wrap: nowrap;

            .btn-cancel {
                width: 50%;
                background-color: white;
                color: black;
                border-color: black;
                border-radius: 0;
                height: 46px;
                text-transform: uppercase;
                font-weight: bold;
                letter-spacing: 2px;
            }

            .btn-confirm {
                width: 50%;
                background-color: black;
                color: white;
                border-color: black;
                border-radius: 0;
                height: 46px;
                text-transform: uppercase;
                font-weight: bold;
                letter-spacing: 2px;

                &.disable {
                    opacity: 0.5;
                }
            }
        }

        .border-item {
            margin-top: 10px;
            img {
                width: 100%;
            }
        }
        .error-text {
            text-align: center;
            color: #ec0000;
            font-size: 10px;
        }
    }



</style>
<style lang="scss">
    #confirm_redeem_gift_modal{

        .modal-dialog{
            margin-left: 2rem;
            margin-right: 2rem;
            .modal-content{

                border-radius: 0px;
            }
        }
    }
</style>
